import { render, staticRenderFns } from "./BaseSidebarNav.vue?vue&type=template&id=4264fb52"
import script from "./BaseSidebarNav.vue?vue&type=script&lang=js"
export * from "./BaseSidebarNav.vue?vue&type=script&lang=js"
import style0 from "./BaseSidebarNav.vue?vue&type=style&index=0&id=4264fb52&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports